import { lazy } from 'react';

const SellProductConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/sell-product',
			component: lazy(() => import('./SellProductContainer'))
		}
	]
};

export default SellProductConfig;
